<template>
  <div class="level-result-screen">
    <div class="level-result-screen__content">
      <p>당신의 수학 선행 정도는</p>
      <p class="level-result-screen__muted">한국 교육과정 중</p>

      <strong>중2 (L7)</strong>

      <p>정도 입니다!</p>

      <BrainMascotPlaceholder compact />

      <div class="level-result-screen__note">
        이제 중2 수준의 메타인지 테스트를 시작하겠습니다.
      </div>

      <button
        class="primary-button level-result-screen__confirm"
        type="button"
        @click="$emit('continue')"
      >
        확인
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import BrainMascotPlaceholder from '@/components/BrainMascotPlaceholder.vue'

defineEmits<{ continue: [] }>()
</script>